import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param labelId string
 * @param assetId string
 * @param organisationId string
 * @return {Promise<any>|Promise}
 */
export default (function (labelId, assetId, organisationId) {
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSET_LABELS_ADD, {
        labelId: labelId,
        assetId: assetId,
        organisationId: organisationId
    });
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, blockUI: true });
    return request.execute();
});
